import React, { useState,useRef ,useEffect} from "react";
import { Empty, Button,Checkbox,Select,TimePicker ,DatePicker,Input} from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import "./timeSheetTable.scss";
import { getFieldStyle } from "../../themes.js";
import dayjs from 'dayjs';
import useTeamTimeSheetStore from "../../store/teamtimesheet.js";
const format = 'HH:mm';

export default function TimeSheetTable({
    isClickable = false,
    titleList,
    data,
    config,
    currentView,
    alist,
    llist,
    showList = false,                                  
    configViewHandler
}) {
    const navigate = useNavigate();
    const [selectAll, setSelectAll] = useState(false);

    const selectApprovarData = alist?.map((member, idx) => {
        return {
            value:member.username,
            label:member.username,
        };
    }); 

    const checkBoxArray=data?.map((ele)=>{
        return {
            type:"",
            selected: false,
            status: ""
         }
    })
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [checkBoxData, setCheckBoxData] = useState(checkBoxArray);
    const { updateLeaveApplicationStatus,deleteLeaveConfigReq } = useTeamTimeSheetStore();

    const ResetCheckBox = () => {
        var checkBoxResetArray=data?.map((ele)=>{
            return {
                type:"",
                selected: false,                          
                status: ""  }
        })
        setCheckBoxData(()=>([...checkBoxResetArray]))
    };
    useEffect(() => {  
        setCheckBoxData(checkBoxArray)
    }, []);

    if ((!data) || data?.length == 0) {
        return <Empty style={{ margin: "60px" }} />;
    }

    function enableDbUpdate (){
        for(let idx = 0; idx < checkBoxData?.length; idx++){
            //console.log("enableDbUpdate checkBoxArray", idx,checkBoxData[idx].selected)      
            if (checkBoxData[idx].selected ) {
                return true
            } 
        }
        return false
    }
    const onCheckBoxChange = (e) => {
        if (e.target.checked) {
            checkBoxData[e.target.value].selected = true; 
            //console.log("Setting checkBoxData", e.target.value,true,checkBoxData)      
        }else{
            checkBoxData[e.target.value].selected = false; 
            //console.log("Setting checkBoxData", e.target.value,false) 
        }
        if (enableDbUpdate() == true){
            setUpdateAvailable(true)

        }else{
            setUpdateAvailable(false)
        } 
        setCheckBoxData(()=>([...checkBoxData]))
      }

    const getUpdated=(rowIndex)=>{
        return checkBoxData?.[rowIndex]?.selected 
    }
    function getTimeNow() {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate;
    }      


    const handleSelectAll = () => {
        const tempCheckBoxData = [...checkBoxData];
        if (selectAll) {
        tempCheckBoxData.forEach((item) => {
            item.selected = false;
        });
        setCheckBoxData(tempCheckBoxData);
        setUpdateAvailable(false);
        } else {
        tempCheckBoxData.forEach((item) => {
            item.selected = true;
        });
        setCheckBoxData(tempCheckBoxData);
        setUpdateAvailable(true);
        }
        setSelectAll(!selectAll);
    };
  
    const handleClick= () =>{

    }
    const handleClickInfo = (tableid, leaveconfigid) =>{
        if(configViewHandler != null)
           configViewHandler("updateconfig",leaveconfigid)
    }
    const handleApproveLeaves = () =>{
        var jasonValues= encodeJson("APPROVED") 
        console.log("Encoded data", jasonValues)
        updateLeaveApplicationStatus(jasonValues)
        ResetCheckBox();
        setUpdateAvailable(false);
        setSelectAll(false)
    }
    const handleRejectLeaves = () =>{
        var jasonValues= encodeJson("REJECTED") 
        console.log("Encoded data", jasonValues)
        updateLeaveApplicationStatus(jasonValues)
        ResetCheckBox();
        setUpdateAvailable(false);
        setSelectAll(false)
    } 
    const handleCancelled = () =>{
        var jasonValues= encodeJson("CANCELLED") 
        console.log("Encoded data", jasonValues)
        updateLeaveApplicationStatus(jasonValues)
        ResetCheckBox();
        setUpdateAvailable(false);
        setSelectAll(false)
    } 
       
    function getSplit (str){
         const parts = str.split("#");
         return parts[0]
    }
    function getQhLid (str){
         const parts = str.split("#");
         return parts[1]
    }    

    const encodeJson = (status) =>{
        let encodedJsonValues ={};
        //get company details
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        //now fill the parameters
        let num=0

        encodedJsonValues.leaveinfo= []
        for(let idx = 0; idx < checkBoxData.length; idx++){
            //console.log("checkBoxData", idx,checkBoxData[idx].selected)
            if (checkBoxData[idx].selected) {
                encodedJsonValues.leaveinfo[num] = {}
                encodedJsonValues.leaveinfo[num].username = data[idx].name;
                encodedJsonValues.leaveinfo[num].qhuid =data[idx].qhuid;
                encodedJsonValues.leaveinfo[num].qhlid =parseInt(getQhLid(data[idx].leavestype),10);           
                num++;
            } 
        }
        encodedJsonValues.status = status      
        //get the current date
        let newDate = getTimeNow()
        encodedJsonValues.updatedby= userData.qhuid;
        encodedJsonValues.updatedbyname= userData.username;
        encodedJsonValues.updatedon    = newDate;
            
        return encodedJsonValues
    }
   
    const encodeJsonDeleted = (status) =>{
        let encodedJsonValues ={};
        //get company details
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        //now fill the parameters
        let num=0

        console.log("get the data", data)
        encodedJsonValues.leaveconfiginfo= []
        for(let idx = 0; idx < checkBoxData.length; idx++){
            //console.log("checkBoxData", idx,checkBoxData[idx].selected)
            if (checkBoxData[idx].selected) {
                encodedJsonValues.leaveconfiginfo[num] = {}
                encodedJsonValues.leaveconfiginfo[num].name = data[idx].leaveconfigname;
                encodedJsonValues.leaveconfiginfo[num].qhlconfigid =data[idx].leaveconfigid;           
                num++;
            } 
        }
        encodedJsonValues.status = "DELETE"      
        //get the current date
        let newDate = getTimeNow()
        encodedJsonValues.updatedby= userData.qhuid;
        encodedJsonValues.updatedbyname= userData.username;
        encodedJsonValues.updatedon    = newDate;
            
        return encodedJsonValues
    }

    const handleUpdates = () =>{

    } 
    const handleDeleteLeaveConfig = () =>{
        var jasonValues= encodeJsonDeleted("DELETE") 
        console.log("Encoded data", jasonValues)
        deleteLeaveConfigReq(jasonValues)
        ResetCheckBox();
        setUpdateAvailable(false);
        setSelectAll(false)
    }   
    return (
        <div className="timeSheetTable-wrapper">
            <div className="timeSheetTable-btn-wrapper"  >
                {
                    currentView=="daily"?
                    <>
                        <Button
                            className="timeSheetTable-btn"
                            disabled={!updateAvailable}
                            onClick={handleUpdates}
                        >
                        Approve Attendance
                        </Button> 
                        <Button
                            className="timeSheetTable-btn"
                            disabled={!updateAvailable}
                            onClick={handleUpdates}
                        >
                        Approve OverTime
                        </Button>                     
                    </>
                    :currentView=="leaves"?
                    <>
                        <Button
                            className="timeSheetTable-btn"
                            disabled={!updateAvailable}
                            onClick={handleApproveLeaves}
                        >
                        Approve Leave
                        </Button> 
                        <Button
                            className="timeSheetTable-btn"
                            disabled={!updateAvailable}
                            onClick={handleRejectLeaves}
                        >
                        Reject Leave
                        </Button>   
                        <Button
                            className="timeSheetTable-btn"
                            disabled={!updateAvailable}
                            onClick={handleCancelled}
                        >
                        Cancel Leave
                        </Button>                                                   
                        <Button
                            className="timeSheetTable-btn"
                            disabled={!updateAvailable}
                            onClick={handleUpdates}
                        >
                        Add Comments
                        </Button>                                             
                    </> 
                    :currentView=="leavesconfig"?
                    <>
                        <Button
                            className="timeSheetTable-btn"
                            disabled={!updateAvailable}
                            onClick={handleDeleteLeaveConfig}
                        >
                           Delete Config
                        </Button>                                                                     
                    </>                                       
                    :<></>
                }                          
            </div>            
            <div
                className="table-title-wrapper"
                style={{
                    gridTemplateColumns: config
                }}
            >
                {titleList.map((title) => (
                    <div className="table-title">
                        {title === "Select" ? (
                        <Checkbox
                            className="table-title-checkbox"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSelectAll()}
                            checked={selectAll}
                        ></Checkbox>
                        ) : (
                        <p className="table-title-text">{title}</p>
                        )}
                    </div>
                ))}
            </div>
            {data?.map((table, rowIndex) => (
                <div
                    onClick={handleClick()}
                    key={table.id}
                    className="table-info-wrapper"
                    style={{
                        gridTemplateColumns: config,
                        cursor: isClickable && "pointer",
                    }}
                >
                    {Object.keys(table)?.map((tableInfo, idx) => (
                        <div className="table-info"
                             style={{
                                ...getFieldStyle(tableInfo, table[tableInfo]),
                             }}
                             onClick={()=> (tableInfo == "leaveconfigname")?handleClickInfo(table.id, table.leaveconfigid):"" }   
                        >
                            {tableInfo === "select" ? (
                                <Checkbox
                                className="checkbox-wrapper"
                                value={rowIndex}
                                onChange={onCheckBoxChange}
                                checked={getUpdated(rowIndex)}
                                ></Checkbox>
                            ) : (
                                <></>
                            )}
                            {tableInfo === "leavestype" ? 
                              <>
                                {
                                    getSplit(table[tableInfo])
                                }
                              </>
                             : (
                                <>{table[tableInfo]}</>
                            )}                                
                               
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
